import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';
import landing from '../Landing';
import LandingBody from '../Landing/LandingBody';

const CarLandingManage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: paramId } = useParams();
  const [form, setForm] = useState<any>({});
  const [cars, setCars] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [posts, setPosts] = useState<string[]>(['']);
  const [banners, setBanners] = useState<any>({});
  const [selectedBrands, setSelectedBrands] = useState<any>([]);
  const [productGroups, setProductGroups] = useState<any>([
    {
      title: '',
      products: []
    },
    {
      title: '',
      products: []
    },
    {
      title: '',
      products: []
    },
  ]);

  const sendLanding = async () => {
    const formData = new FormData();

    Object.entries(banners).map(([primaryKey, primaryValue]) => {
      Object.entries(primaryValue).map(([key, value]) => {
        formData.append(key, value);
      });
      formData.append('code', primaryKey);
    });

    const landing = await restApi(endpoints.landing.basic + (form.landingId || '')).post(form);

    const res = await Promise.all([
      restApi(endpoints.landing.productGroups + landing.data.id).put({ productGroups: productGroups }),
      restApi(endpoints.landing.brands + landing.data.id).put({ brands: selectedBrands }),
      restApi(endpoints.landing.posts + landing.data.id).put({ posts: posts }),
      restApi(endpoints.landing.banners + landing.data.id).upload(formData),
    ]);

    return landing.id

  };

  const send = async () => {
    dispatch(setLoading(true));

    const landingId = await sendLanding();

    const res = await restApi(endpoints.landing.carLandingBasic + (paramId || '')).post({
      landingId: form.landingId,
      carId: form.carId,
      categoryId: form.categoryId,
      meta1: form.meta1,
      meta2: form.meta2,
    });

    if (res.code == 200) {
      Swal.fire({
        title: 'موفق',
        text: `لندینگ با موفقیت ${paramId ? 'ویرایش' : 'ساخته'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          // navigate('/landing');
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res[0]?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }
    dispatch(setLoading(false));
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      await restApi(endpoints.category.index).get(),
      await restApi(endpoints.car.index).get(),
      await restApi(endpoints.brand.index).get(),
      await restApi(endpoints.product.index).get(),
      paramId && await restApi(endpoints.landing.carLanding + paramId).get()
    ]);

    setCategories(res[0].data);
    setCars(res[1].data);
    setBrands(res[2].data);
    setProducts(res[3].data);
    if (paramId) {
      const newBanners = {};

      res[4].data.landing.banners?.map(e => {
        newBanners[e.code] = {
          preview: e.media.url,
          mediaId: e.media.id,
          data: undefined,
          alt: e.title,
          link: e.link,
        };
      });

      setBanners(newBanners);

      setPosts(res[4].data?.landing?.posts?.map(e => process.env.REACT_APP_BLOG_URL + '/' + e.slug));

      setSelectedBrands(res[4].data.landing.brands.map(e => e.id));

      setForm({
        title: res[4].data.landing.title,
        description: res[4].data.landing.description,
        landingId: res[4].data.landingId,
        carId: res[4].data.carId,
        categoryId: res[4].data.categoryId,
        meta1: res[4].data.meta1,
        meta2: res[4].data.meta2,
      });

      setProductGroups(res[4].data.landing.productGroups.map((e, index) => {
        return {
          title: e.title,
          products: e.products.map(e => e.id.toString())
        };
      }));
    }
    dispatch(setLoading(false));
  };
  console.log(banners);
  useEffect(() => {
    fetchData();
  }, []);
  console.log(form);
  return (
    <>
      <main className="dashboardBody">
        <Sidebar/>
        <div className="landingMain">
          <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
            {paramId ? 'ویرایش' : 'ثبت'} لندینگ
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه لندینگ</h1>
             <h1 className="dashBoardTitle">{paramId ? `ویرایش لندینگ ${form.title}` : 'افزودن لندینگ جدید'}</h1>
          </span>
            <i className="backAdd clickable" onClick={() => navigate('/carLanding/')}></i>
          </div>
          <section className="landing">
            <label>ماشین</label>
            <Select options={tools.selectFormatter(cars, 'id', 'slug', 'انتخاب کنید')} value={tools.selectFormatter(cars?.filter(e => e.id == form.carId), 'id', 'slug')} className="width100"
                    onChange={(selected) => setForm(prev => ({
                      ...prev,
                      carId: selected.value.toString()
                    }))}
            />
            <label>دسته بندی</label>
            <Select options={tools.selectFormatter(categories, 'id', 'title', 'انتخاب کنید')} value={{ value: form?.categoryId , label: categories.find(e => e.id == form?.categoryId)?.title }} className="width100" id="infoTitle" onChange={(selected: any) => setForm(prev => ({...prev, categoryId: selected.value }))}/>
            <label>متا ۱</label>
            <textarea className="persianName" defaultValue={form?.meta1} onChange={(input) => setForm((prev) => ({
              ...prev,
              meta1: input.target.value
            }))}/>
            <label>متا ۲</label>
            <textarea className="persianName" defaultValue={form?.meta2} onChange={(input) => setForm((prev) => ({
              ...prev,
              meta2: input.target.value
            }))}/>
          </section>
          <LandingBody brands={brands} productGroups={productGroups} products={products} banners={banners} selectedBrands={selectedBrands} setSelectedBrands={setSelectedBrands} setProductGroups={setProductGroups} setBanners={setBanners} form={form} setForm={setForm} posts={posts} setPosts={setPosts} />
        </div>
      </main>
    </>
  );
};
export default CarLandingManage;